export default "__VITE_ASSET__xdzp3AJ5__"